/*
 * escuela-variant-guard.js
 *
 * Solo para productos con el tag "escuela" (se inyecta desde main-product.liquid
 * únicamente en esos productos).
 *
 * Los valores de la opción "Horarios" llevan el centro dentro ("Barcelona -
 * Grupo de mañanas - ..."), así que cambiar de Centro produce SIEMPRE una
 * combinación que no existe como variante. Shopify resuelve ese caso bien:
 * devuelve selected_or_first_available_variant = null, mantiene el centro
 * elegido y recalcula qué horarios están disponibles en el nuevo contexto. El
 * tema también lo trata bien (product-info.js: updateOptionValues + vacía el
 * input id + setUnavailable), así que NO hay que frenar ese repintado.
 *
 * Lo único que el tema no hace con variante nula es avisar al app block de
 * compra: sale antes de emitir 'variant:changed'. Eso es lo que cubrimos aquí.
 *
 * OJO: no se puede escuchar sobre <variant-selects>. Al repintar, el tema lo
 * sustituye por un nodo nuevo (HTMLUpdateUtility.viewTransition inserta y
 * elimina), y cualquier listener atado a él se pierde en el primer cambio. Por
 * eso delegamos en <product-info>, que sí sobrevive al repintado.
 */
(function () {
  var dataEls = document.querySelectorAll('product-info [data-escuela-variants]');

  dataEls.forEach(function (dataEl) {
    var productInfo = dataEl.closest('product-info');
    if (!productInfo) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants)) return;

    // Índice: valores de opción unidos -> variante existente.
    var byOptions = {};
    variants.forEach(function (v) {
      if (v && v.options) byOptions[v.options.join('~~')] = v;
    });

    // Lee la combinación seleccionada, en orden de opción. Se vuelve a buscar
    // <variant-selects> en cada llamada porque el tema lo reemplaza al repintar.
    function currentSelection() {
      var variantSelects = productInfo.querySelector('variant-selects');
      if (!variantSelects) return null;

      var groups = variantSelects.querySelectorAll('.product-form__input');
      var values = [];
      groups.forEach(function (group) {
        var sel = group.querySelector('select');
        if (sel) {
          values.push(sel.value);
          return;
        }
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) values.push(checked.value);
      });
      // Si algún grupo no da valor, la lectura es incompleta: no podemos decidir
      // si la combinación existe, y dar por inexistente lo que no lo es
      // ocultaría el botón de reserva en una combinación buena.
      if (values.length !== groups.length) return null;
      return values;
    }

    // Fase de burbujeo y sin cortar la propagación: el tema hace su trabajo
    // (repinta el selector con la disponibilidad del centro ya elegido) y
    // nosotros solo añadimos el aviso que le falta cuando no hay variante.
    productInfo.addEventListener('change', function (event) {
      // Este filtro es imprescindible, no cosmético: updateVariantInputs lanza
      // un 'change' sintético con bubbles:true sobre input[name="id"], que vive
      // en el form, fuera de <variant-selects>. Sin el filtro nos reentraría.
      if (!event.target.closest || !event.target.closest('variant-selects')) return;

      var values = currentSelection();
      if (!values || !values.length) return;
      if (byOptions[values.join('~~')]) return; // combinación válida -> ya avisa el tema

      document.dispatchEvent(
        new CustomEvent('variant:changed', { detail: { variant: null } })
      );
    });
  });
})();
